import React, { useEffect } from 'react';
import { twMerge } from 'tailwind-merge';
import hash from 'object-hash';
import { SlideshowComponent } from './SlideshowComponent';

export const FeaturedSlideshow = ({ props }) => {
  const slideshowType = props.type;
  const array = props.slides;
  // console.log(slideshowType);
  // console.log(array);
  const isFeatured = true;

  let uuid = hash(
    array.map((entry) => {
      const obj = {
        key: entry.image.id,
        img: entry.image.publicURL,
        position: `object-${entry.position}`,
      };
      return obj;
    })
  );
  uuid = `hash-${uuid}`;

  const images = array.map((entry) => {
    const singleSlideClass = twMerge(`object-${entry.position}`);
    const image = {
      slide: `${uuid}-${entry.image.id}`,
      url: entry.image.publicURL,
      position: singleSlideClass,
      alt: entry.alt,
    };
    return image;
  });

  // console.log(images);

  const contents = array.map((entry) => {
    const content = {
      slide: `${uuid}-${entry.image.id}`,
      content: entry.content,
    };
    return content;
  });

  // console.log(contents);

  return SlideshowComponent(images, contents, slideshowType, uuid, isFeatured);
};
